import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const trustItems = ['Pagamento unico', 'Accesso immediato', 'Pronto da stampare'];
export function Hero() {
  return <section className="w-full bg-cream px-6 pb-12 pt-10 sm:px-5 sm:pb-20 sm:pt-16" data-id="element-109" data-mp="9l341bdfia3g">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-110" data-mp="4n1j0kwg00pc">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[11px] font-extrabold uppercase leading-tight tracking-[0.2em] text-mint sm:text-xs sm:tracking-[0.24em]" data-id="element-111" data-mp="128frrovbsnyc">
          Primaria e Secondaria · Età 6-14 anni
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 text-[34px] font-extrabold leading-[1.08] tracking-tight text-navy sm:mt-5 sm:text-5xl lg:text-[3.6rem]" data-id="element-112" data-mp="3d21uc37gquqd">
          Insegna un Anno Intero di <em className="italic text-grape" data-id="element-113" data-mp="3o6u697yqynbv">Musica</em> in Soli 5 Minuti di
          Preparazione
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 max-w-2xl text-[15px] leading-relaxed text-ink-soft sm:mt-6 sm:text-lg" data-id="element-114" data-mp="39cpain8uf6z7">
          Musica Pronta è il curricolo musicale completo, pronto all'uso, per la scuola primaria e
          secondaria italiana. 10 volumi, 60 unità didattiche, zero ore spese a preparare le lezioni
          da zero.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 w-full sm:mt-10" data-id="element-115" data-mp="2hinbaf5jgejw">
          <img src="https://cdn.magicpatterns.com/uploads/1XLvfH52s8rPP13LPvJk8d/Mockup_V2_transparente_(chatgpt).png" alt="Il pack Musica Pronta: 10 volumi per primaria e secondaria, materiali digitali e 5 bonus stampabili" className="mx-auto w-full max-w-2xl object-contain" width={1536} height={1024} data-id="element-116" data-mp="s3ck463mvbog" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-6 w-full sm:mt-8" data-id="element-117" data-mp="1b04cr652f356">
          <CTAButton data-id="element-118" data-mp="x14nbw9qak7y" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-ink-soft sm:mt-5 sm:gap-x-6 sm:text-sm" data-id="element-119" data-mp="x1w8ed5p8zjz">
            {trustItems.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-120" data-mp="3hr3rdunnk95a">
                <CheckIcon className="h-3.5 w-3.5 flex-none text-mint" aria-hidden="true" data-id="element-121" data-mp="1x9b5n20k33d3" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}